module.exports = __webpack_public_path__ + "img/m01.8fd4818c.png";